import { Button, Col, Row } from 'reactstrap';
import { Field, Form } from 'react-final-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { actions } from '../../context';
import {
    faFileAlt,
    faPaperclip,
    faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import FieldTitle from './FieldTitle';
import createDecorator from 'final-form-calculate';

const tagReseter = createDecorator({
    field: 'activityTagGroupId',
    updates: {
        activityTagId: (value, allValues) => {},
    },
});

const NewActivityForm = (props) => {
    const { practiceId, cancelCallback, onComplete } = props;

    const dispatch = useDispatch();
    const [files, setFiles] = useState([]);
    const [tags, setTags] = useState([]);

    useEffect(() => {
        var form = document.getElementById('activityForm');
        if (form) form.reset();
        if (practiceId)
            dispatch(actions.notes.getTags()).then((res) =>
                setTags(res?.data || [])
            );
        // eslint-disable-next-line
    }, [dispatch]);

    const submit = async (values, form) => {
        var formData = new FormData();
        formData.append('practiceGuid', practiceId);
        formData.append('note.activityTagGroupId', values.activityTagGroupId);
        formData.append('note.activityTagId', values.activityTagId);
        formData.append('note.content', values.content);
        var elem = document.getElementById('noteFiles');
        if (elem)
            Array.from(elem.files).forEach((file) =>
                formData.append('files', file)
            );

        dispatch(actions.notes.createNote(formData)).then((res) => {
            onComplete(res.data);
            closeForm(form);
            dispatch(actions.toggle.activitiesRefresh());
        });
    };

    const fileInputChange = (e) => {
        setFiles([]);
        let fileList = [];
        Array.from(e.target.files).forEach((file) => fileList.push(file.name));
        setFiles(fileList);
    };

    const clearFiles = () => {
        const inputElement = document.getElementById('noteFiles');
        inputElement.value = '';
        setFiles([]);
    };
    const fileNameDisplayLength = 25;

    const cancel = (form, pristine) => {
        if (!pristine) {
            form.reset();
            clearFiles();
        } else {
            closeForm(form);
        }
    };

    const closeForm = (form) => {
        form.reset();
        clearFiles();
        cancelCallback();
    };

    return (
        <div className="text-light p-2 px-4">
            <h2>New Activity</h2>
            <br />
            <Form
                onSubmit={submit}
                decorators={[tagReseter]}
                render={({
                    handleSubmit,
                    form,
                    submitting,
                    pristine,
                    values,
                }) => (
                    <form id="activityForm" onSubmit={handleSubmit}>
                        <Row>
                            <Col lg="8" md="8" sm="8" xs="8">
                                <FieldTitle title="Details" required />
                                <Field
                                    className="w-100 rounded p-2"
                                    component="textarea"
                                    placeholder="Activity Details"
                                    name="content"
                                    required
                                    rows="10"
                                />
                            </Col>
                            <Col lg="4" md="4" sm="4" xs="4">
                                <FieldTitle title="Tag Group" required />
                                <Field
                                    name="activityTagGroupId"
                                    component="select"
                                    className="w-100 rounded p-2"
                                    required
                                    label="Tag Group"
                                    defaultValue="">
                                    <option value="" disabled>
                                        Tag Group
                                    </option>
                                    {(tags || []).map((t, x) => (
                                        <option key={`tagGrp-${t.id}-${x}`} value={t.id}>
                                            {t.name}
                                        </option>
                                    ))}
                                </Field>
                                <br />
                                <br />
                                <FieldTitle title="Tag" required />
                                <Field
                                    name="activityTagId"
                                    component="select"
                                    className="w-100 rounded p-2"
                                    required
                                    label="Tag"
                                    defaultValue="">
                                    <option value="" disabled>
                                        Tag
                                    </option>
                                    {(
                                        tags?.filter(
                                            (t) =>
                                                t?.id?.toString() ===
                                                values?.activityTagGroupId
                                        )[0]?.tags || []
                                    ).map((t, x) => (
                                        <option key={`tag-${t.id}-${x}`} value={t.id}>
                                            {t.name}
                                        </option>
                                    ))}
                                </Field>
                            </Col>
                        </Row>
                        <Row>
                            <Col
                                xs="12"
                                className="d-flex justify-content-between">
                                <div>
                                    <label
                                        className="file-upload p-2"
                                        title="Upload a file or screenshot">
                                        <input
                                            type="file"
                                            id="noteFiles"
                                            onChange={(e) => fileInputChange(e)}
                                            multiple
                                        />
                                        <FontAwesomeIcon
                                            icon={faPaperclip}
                                            size="lg"
                                        />
                                    </label>
                                    {files.map((file, index) => (
                                        <div
                                            className="bg bg-info text-light d-inline-block ml-4 p-2 rounded"
                                            title={file}
                                            key={index}>
                                            <FontAwesomeIcon
                                                size="lg"
                                                icon={faFileAlt}
                                            />
                                            &emsp;{' '}
                                            {file.substring(
                                                0,
                                                fileNameDisplayLength
                                            ) +
                                                (file.length >
                                                fileNameDisplayLength
                                                    ? `...`
                                                    : '')}
                                            &emsp;{' '}
                                            <FontAwesomeIcon
                                                icon={faTimes}
                                                onClick={() => clearFiles()}
                                                size="lg"
                                                title="Remove this File"
                                                className="hoverable"
                                            />
                                        </div>
                                    ))}
                                </div>
                                <div>
                                    <Button
                                        color="danger"
                                        className="mx-1"
                                        onClick={() => cancel(form, pristine)}>
                                        {pristine ? 'Cancel' : 'Clear'}
                                    </Button>
                                    <Button
                                        color="success"
                                        className="mx-1"
                                        disabled={
                                            (pristine && files.length < 1) ||
                                            submitting
                                        }>
                                        Save
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </form>
                )}
            />
        </div>
    );
};

export default NewActivityForm;
